import classNames from 'classnames/bind';
import React from 'react';
import Button, { ButtonMode } from '../Button';
import Icon, { ICONS } from '../Icon';
import Tooltip from '../Tooltip';
import styles from './InfoIndicator.module.scss';

const cx = classNames.bind(styles);

interface InfoIndicatorProps {
  tooltipText: string;
  onClick?: () => void;
}
const InfoIndicator = ({ tooltipText, onClick }: InfoIndicatorProps): React.ReactElement => {
  return (
    <Tooltip
      trigger={
        onClick ? (
          <Button mode={ButtonMode.PLAIN} className={cx('body')} onClick={onClick} aria-label={tooltipText}>
            <Icon name={ICONS.Info} dataTestId="info-button-icon" />
          </Button>
        ) : (
          <span className={cx('body')}>
            <Icon name={ICONS.Info} dataTestId="info-button-icon" ariaLabel={tooltipText} />
          </span>
        )
      }
      content={tooltipText}
    />
  );
};
export default InfoIndicator;
